import { createRoot } from "react-dom/client";
import "./styles/fonts.css";
import "./assets/fonts/wenkai-subset.css";

import App from "./App";
import { BirthdayEntry } from "./components/BirthdayEntry/BirthdayEntry";
import "./styles/tokens.css";
import "./styles/global.css";

createRoot(document.getElementById("root")!).render(<BirthdayEntry><App /></BirthdayEntry>);
